<template>
  <tr>
    <td>
      <kv-suggestor
        :item="interlocuteur.role_id"
        :type="'roles'"
        @update="update('role_id', $event)"
        :inline="true"
      ></kv-suggestor>
    </td>
    <td>
      <partner-suggestor
        :item="interlocuteur.partner_id"
        @update="update('partner_id', $event)"
        :inline="true"
      ></partner-suggestor>
    </td>
    <td>
      <contact-suggestor
        :item="interlocuteur.contact_id"
        :partner-context="interlocuteur.partner_id"
        @update="update('contact_id', $event)"
        :inline="true"
      ></contact-suggestor>
    </td>
    <td>
      <kv-suggestor
        :item="interlocuteur.statut_id"
        :type="'statuts'"
        @update="update('statut_id', $event)"
        :inline="true"
      ></kv-suggestor>
    </td>
    <td>
      <button class="button is-danger" @click="$emit('remove')">
        <i class="fa fa-times"></i>
      </button>
    </td>
  </tr>
</template>
<script>
import ContactSuggestor from "./ContactSuggestor";
import KvSuggestor from "./KvSuggestor";
import PartnerSuggestor from "./PartnerSuggestor";

export default {
  name: "InterlocuteurRow",
  components: { ContactSuggestor, KvSuggestor, PartnerSuggestor },
  props: {
    interlocuteur: {
      type: Object,
      required: true
    }
  },
  methods: {
    update(key, $event) {
      this.$emit("update", {
        key,
        val: $event
      });
    }
  }
};
</script>
